if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.consentRecorded = false;
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
        return;
      }

      // Consent is given. Record it on the cart so it lands on the order,
      // then let the original submission continue.
      if (this.consentRecorded) return;

      evt.preventDefault();
      this.consentRecorded = true;

      const submitter = evt.submitter;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const locale = document.documentElement.lang || '';
      const value = 'accepted ' + new Date().toISOString() + ' | licence-agreement v5 | ' + locale;

      const resume = () => {
        if (submitter && submitter.name) {
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = submitter.name;
          hidden.value = submitter.value || '';
          this.form.appendChild(hidden);
        }
        this.form.submit();
      };

      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { license_consent: value } })
      })
        .catch(() => {
          // Recording failed. Let the purchase through rather than blocking a
          // sale on a network hiccup; the missing attribute on the order is
          // the signal that consent was not captured for that order.
        })
        .finally(resume);
    }
  }
  customElements.define('cart-terms', CartTerms);
}
